import { render, staticRenderFns } from "./SelectFarmDialog.vue?vue&type=template&id=f1bbbcd6"
import script from "./SelectFarmDialog.vue?vue&type=script&lang=js"
export * from "./SelectFarmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports